import script from "./Class.vue?vue&type=script&setup=true&lang=js"
export * from "./Class.vue?vue&type=script&setup=true&lang=js"

import "./Class.vue?vue&type=style&index=0&id=54c8ac6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c8ac6f"]])

export default __exports__